import { Box, Container, Paper, Typography } from '@mui/material'
import { steps } from '../../data/landing'

export default function HowItWorks() {
  return (
    <Box
      id="how-it-works"
      component="section"
      sx={{ py: { xs: 8, md: 10 } }}
    >
      <Container maxWidth="lg">
        <Box sx={{ mb: { xs: 4, md: 5 } }}>
          <Typography
            variant="overline"
            sx={{
              display: 'block',
              color: 'rgba(255,255,255,0.55)',
              letterSpacing: '0.12em',
              mb: 1,
            }}
          >
            How it works
          </Typography>

          <Typography
            variant="h3"
            sx={{
              fontWeight: 700,
              lineHeight: 1.2,
              fontSize: { xs: '2rem', sm: '2.4rem', md: '3rem' },
            }}
          >
            Simple 4-step process
          </Typography>
        </Box>

        <Box
          component="ol"
          sx={{
            display: 'grid',
            gridTemplateColumns: {
              xs: '1fr',
              sm: 'repeat(2, minmax(0, 1fr))',
              md: 'repeat(4, minmax(0, 1fr))',
            },
            gap: 3,
            listStyle: 'none',
            p: 0,
            m: 0,
            counterReset: 'step',
          }}
        >
          {steps.map((item, index) => (
            <Box component="li" key={item.title} sx={{ display: 'flex' }}>
              <Paper
                elevation={0}
                sx={{
                  position: 'relative',
                  display: 'flex',
                  flexDirection: 'column',
                  width: '100%',
                  height: '100%',
                  p: 3,
                  borderRadius: 4,
                  background: 'rgba(255,255,255,0.03)',
                  border: '1px solid rgba(255,255,255,0.08)',
                  color: '#fff',
                  transition:
                    'transform 0.25s ease, border-color 0.25s ease, box-shadow 0.25s ease',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.12)',
                  overflow: 'hidden',
                  '&:hover': {
                    transform: 'translateY(-4px)',
                    borderColor: 'rgba(255,255,255,0.16)',
                    boxShadow: '0 16px 40px rgba(0,0,0,0.22)',
                  },
                  '&::before': {
                    content: '""',
                    position: 'absolute',
                    inset: 0,
                    background:
                      'linear-gradient(180deg, rgba(255,255,255,0.04), rgba(255,255,255,0))',
                    pointerEvents: 'none',
                  },
                }}
              >
                <Box
                  sx={{
                    position: 'relative',
                    zIndex: 1,
                    width: 52,
                    height: 52,
                    borderRadius: 3,
                    bgcolor: '#fff',
                    color: '#111',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontWeight: 800,
                    fontSize: '1.05rem',
                    mb: 2.5,
                    boxShadow: '0 8px 24px rgba(255,255,255,0.12)',
                  }}
                >
                  {String(index + 1).padStart(2, '0')}
                </Box>

                <Typography
                  variant="h6"
                  sx={{
                    position: 'relative',
                    zIndex: 1,
                    fontWeight: 700,
                    mb: 1.5,
                    lineHeight: 1.35,
                  }}
                >
                  {item.title}
                </Typography>

                <Typography
                  sx={{
                    position: 'relative',
                    zIndex: 1,
                    color: 'rgba(255,255,255,0.72)',
                    lineHeight: 1.75,
                    fontSize: '0.98rem',
                  }}
                >
                  {item.text}
                </Typography>
              </Paper>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  )
}